import { i18n } from "../i18n";
import { ApiError } from "./client";

/**
 * What the operator reads when something fails — localized by `error.code`
 * (the `errors` namespace has every ErrorCode plus NETWORK), never by the
 * server's message text. A code this build does not know falls back to the
 * server's English message, which is always specific.
 */
export function errorMessage(error: unknown): string {
	if (error instanceof ApiError) {
		if (error.code === "RATE_LIMITED") return rateLimitMessage(error);
		return i18n.t(`errors:${error.code}`, { defaultValue: error.message });
	}
	return i18n.t("errors:GENERIC");
}

function rateLimitMessage(error: ApiError): string {
	const seconds = Number(error.details?.["retry_after_seconds"] ?? 0);
	if (!Number.isFinite(seconds) || seconds <= 0) return i18n.t("errors:RATE_LIMITED_noRetry");
	if (seconds < 60) return i18n.t("errors:RATE_LIMITED_waitSeconds", { count: Math.ceil(seconds) });
	return i18n.t("errors:RATE_LIMITED_waitMinutes", { count: Math.ceil(seconds / 60) });
}

/** No answer / dependency down — keep everything; never offer "sign in again". */
export const isTransientError = (error: unknown): boolean => error instanceof ApiError && error.transient;

/** The request id is worth showing only when support could act on it (our fault, or no answer). */
export function supportRequestIdOf(error: unknown): string | null {
	if (!(error instanceof ApiError)) return null;
	return error.status >= 500 || error.transient ? error.requestId : null;
}
